import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LegionellaVisitSubmission } from '../models/legionella.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpLegionellaService {

  constructor(private http: HttpClient) { }

  addVisit(visit: LegionellaVisitSubmission): Observable<number> {
    return this.http.post<number>(
      environment.baseUrl + 'weedfree/form/legionella/add-visit',
      visit
    );
  }

  addVisitFiles(visitId: number, files: any[]) {
    let form = new FormData();

    for (const f of files) {
      form.append('files[]', f, f.name);
    }

    return this.http.post(
      environment.baseUrl + 'weedfree/form/legionella/upload-files', 
      form,
      {
        reportProgress: true,
        observe: 'events',
        params: { visit: visitId }
      }).pipe(map((e) => {
        switch (e.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round(100*e.loaded / e.total);
            return { status: 'progress', message: progress };
          case HttpEventType.Response:
            return { status: 'complete', message: e.body };
          default:
            return { status: 'error', message: 'Unhandled event: ' + e.type };
        }
      })
    );

  }


}
